import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { userLogout } from '../../store/authActions';
import Cookies from "js-cookie";
import ConfirmPopupHeader from './ConfirmPopupHeader';
import { getImageUrl } from '../../utils/imageHelper';

const getAuthToken = () => {
  try {
    const raw = Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser");
    if (!raw) return null;
    const decoded = decodeURIComponent(raw);
    try {
      return JSON.parse(decoded);
    } catch {
      return decoded;
    }
  } catch {
    return null;
  }
};

function HeaderUser() {
  const token = getAuthToken();
  const navigate = useNavigate()
  const { userDetailLogin, planChangeStatus } = useSelector((state) => state.auth);
  const dispatch = useDispatch()

  const [formData, setFormData] = useState({})
  const location = useLocation()
  const [popupMessage, setPopupMessage] = useState("")

  const modalConfirmRef = useRef(null)
  const modalInstanceConfirm = useRef(null);


  const [isHeaderOpen, setHeaderOpen] = useState(false);

  const [openMegaMenu, setOpenMegaMenu] = useState(null);
  const [openMegaMenuMatch, setOpenMegaMenuMatch] = useState(null);
  const [openMegaMenuSearch, setOpenMegaMenuSearch] = useState(null);
  const [openMegaMenuInbox, setOpenMegaMenuInbox] = useState(null);
  const [userPlanDetail, setUserPlanDetail] = useState({})
  const [confirmYesNo, setConfirmYesNo] = useState(false)
  const [profileCompletion, setProfileCompletion] = useState("0%")

  const toggleHeader = () => {


    if (isHeaderOpen) {
      setOpenMegaMenu(false);
      setOpenMegaMenuMatch(false);
      setOpenMegaMenuSearch(false);
      setOpenMegaMenuInbox(false);
    }

    setHeaderOpen((prev) => !prev);

  };



  const toggleMegaMenu = () => {
    setOpenMegaMenu((prev) => !prev);
  };
  const toggleMegaMenuMatch = () => {
    setOpenMegaMenuMatch((prev) => !prev);
  };
  const toggleMegaMenuSearch = () => {
    setOpenMegaMenuSearch((prev) => !prev);
  };
  const toggleMegaMenuInbox = () => {
    setOpenMegaMenuInbox((prev) => !prev);
  };

  // globally disable right-click, copy, paste, cut, and common keyboard shortcuts
  // also prevent text selection
  useEffect(() => {
    const block = (e) => e.preventDefault();
    const keyHandler = (e) => {
      if ((e.ctrlKey || e.metaKey) && ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', block);
    document.addEventListener('copy', block);
    document.addEventListener('paste', block);
    document.addEventListener('cut', block);
    document.addEventListener('selectstart', block);
    document.addEventListener('keydown', keyHandler);
    // also set CSS to none for body
    const prevUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = 'none';

    return () => {
      document.removeEventListener('contextmenu', block);
      document.removeEventListener('copy', block);
      document.removeEventListener('paste', block);
      document.removeEventListener('cut', block);
      document.removeEventListener('selectstart', block);
      document.removeEventListener('keydown', keyHandler);
      document.body.style.userSelect = prevUserSelect;
    };
  }, []);





  const handleAuthSessionError = () => {
    Cookies.remove("authTokenUserLogin");
    Cookies.remove("authTokenUser");
    document.location.href = "/";
  };

  const fetchUserDetail = async (userId) => {
    if (!token) {
      handleAuthSessionError();
      return;
    }

    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    });

    if (res.status === 401) {
      handleAuthSessionError();
      return;
    }

    const data = await res.json();

    if (!data.status && (data.message === "Unauthorized!" || data.message === "Session expired. Please log in again" || data.message === "Token missing" || data.message === "Invalid or expired token")) {
      handleAuthSessionError();
      return;
    }

    if (data.status) {


      const dob = new Date(data.data[0].dob);
      let ampm = "AM";
      let hour = dob.getHours();
      if (hour >= 12) {
        ampm = "PM";
        if (hour > 12) hour -= 12;
      } else if (hour === 0) {
        hour = 12;
      }


      let profilePhoto;
      if (data.data[0].profile_photo === 1) {
        profilePhoto = data.data[0].photo
      } else if (data.data[0].profile_photo === 2) {
        profilePhoto = data.data[0].photo1
      } else if (data.data[0].profile_photo === 3) {
        profilePhoto = data.data[0].photo2
      } else if (data.data[0].profile_photo === 4) {
        profilePhoto = data.data[0].photo3
      } else if (data.data[0].profile_photo === 5) {
        profilePhoto = data.data[0].photo4
      } else {
        profilePhoto = data.data[0].photo
      }


      //console.log(data.data[0].plan_detail.advance_search)
      setUserPlanDetail(data.data[0].plan_detail)

      setFormData({

        name: data.data[0].name,
        gender: data.data[0].gender,
        photo: profilePhoto,
        planDetail: data.data[0].plan_detail,
        form_status: data.data[0].form_status,
        data: data.data[0],


      })

    }

  }

  useEffect(() => {
    if (!token) {
      handleAuthSessionError();
      return;
    }
    if (userDetailLogin?._id) {
      fetchUserDetail(userDetailLogin._id)
    } else {
      handleAuthSessionError();
    }

  }, [userDetailLogin, planChangeStatus, token])


  const userLogoutButton = () => {

    dispatch(userLogout())
    document.location.href = `/`

  }

  useEffect(() => {

    setOpenMegaMenu(false)
    setHeaderOpen(false);

  }, [location.pathname])


  useEffect(() => {
    // Initialize Bootstrap modal once (after first render)
    const modalConfirmEl = document.getElementById("confirmPopupHeaderId");
    if (modalConfirmEl) {
      modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
    }


  }, []);


  const showConfirm = () => {
    setPopupMessage("0 view your matches, you must fill out your partner preferences, specifically at least Religion and Caste.")
    setConfirmYesNo(false)
    modalInstanceConfirm.current?.show();
  }

  const yesNoButton = (value) => {

    //console.log('confirm', value)
    setConfirmYesNo(false)
    if (value === 'Yes') {
      navigate("/partner-basic-detail-edit")
    }
    modalInstanceConfirm.current?.hide();
  }

  const showAdvanceForm = () => {
    //console.log(userPlanDetail?.advance_search)  
    if (String(userPlanDetail?.advance_search) === "true") {
      //console.log('kkk')
      setTimeout(() => navigate("/advance-search"), 100);

    } else {
      setPopupMessage(`You're currently on the ${userPlanDetail?.plan_id?.name || 'Basic'} plan. Kindly upgrade your plan to continue.`)
      setConfirmYesNo(true)
      modalInstanceConfirm.current?.show();

    }

  }
  const yesNoButtonTwo = (value) => {

    //console.log('confirm', value)
    setConfirmYesNo(false)
    if (value === 'Yes') {
      navigate("/membership-plan")
    }
    modalInstanceConfirm.current?.hide();
  }


  const checkProfileComplete = async (userId) => {
    if (!token) return;
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/check-profile-complete`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ user_id: userId })
    });

    if (res.status === 401) {
      handleAuthSessionError();
      return;
    }

    const data = await res.json();
    if (data.status) {
      setProfileCompletion(data.completion)

    }
  }


  const handleCompleteProfile = (value, inputData) => {
    const targetData = inputData || formData?.data || formData || {};
    const isMissing = (fieldValue) =>
      fieldValue === null ||
      fieldValue === undefined ||
      (typeof fieldValue === "string" && fieldValue.trim() === "") ||
      (Array.isArray(fieldValue) && fieldValue.length === 0);

    if (
      isMissing(targetData.profile_for) ||
      isMissing(targetData.gender) ||
      isMissing(targetData.name) ||
      isMissing(targetData.marital_status) ||
      isMissing(targetData.height) ||
      isMissing(targetData.weight) ||
      isMissing(targetData.complexion) ||
      isMissing(targetData.hobbies) ||
      isMissing(targetData.diet) ||
      isMissing(targetData.drinking) ||
      isMissing(targetData.smoking) ||
      isMissing(targetData.about)
    ) {
      window.location.href = "/basic-details-edit";
    } else if (
      isMissing(targetData.dob) ||
      isMissing(targetData.manglik) ||
      isMissing(targetData.birth_state) ||
      isMissing(targetData.birth_city)
    ) {
      window.location.href = "/horoscope-details-edit";
    } else if (
      isMissing(targetData.contact_email) ||
      isMissing(targetData.contact_no) ||
      isMissing(targetData.reference)
    ) {
      window.location.href = "/contact-information-edit";
    } else if (
      isMissing(targetData.religion) ||
      isMissing(targetData.caste)
    ) {
      window.location.href = "/religion-edit";
    } else if (
      isMissing(targetData.loc_nationality) ||
      isMissing(targetData.loc_residence_type) ||
      isMissing(targetData.loc_house_type) ||
      isMissing(targetData.loc_state) ||
      isMissing(targetData.loc_city) ||
      isMissing(targetData.loc_temp_state) ||
      isMissing(targetData.loc_temp_city) ||
      isMissing(targetData.loc_temp_pincode)
    ) {
      window.location.href = "/location-detail-edit";
    } else if (
      isMissing(targetData.family_type) ||
      isMissing(targetData.family_value) ||
      isMissing(targetData.health_information) ||
      isMissing(targetData.disability) ||
      isMissing(targetData.blood_group)
    ) {
      window.location.href = "/family-detail-edit";
    } else if (
      (isMissing(targetData.highest_degree) && isMissing(targetData.college_name) && isMissing(targetData.other_education)) ||
      isMissing(targetData.annual_income) ||
      isMissing(targetData.occupation) ||
      isMissing(targetData.organization_name)
    ) {
      window.location.href = "/education-detail-edit";
    } else if (
      isMissing(targetData.partner_age_from) ||
      isMissing(targetData.partner_age_to) ||
      isMissing(targetData.partner_weight_from) ||
      isMissing(targetData.partner_weight_to) ||
      isMissing(targetData.partner_height_from) ||
      isMissing(targetData.partner_height_to) ||
      isMissing(targetData.partner_complexion) ||
      isMissing(targetData.partner_language) ||
      isMissing(targetData.partner_marital_status) ||
      isMissing(targetData.partner_children) ||
      isMissing(targetData.partner_mother_tongue) ||
      isMissing(targetData.partner_country) ||
      isMissing(targetData.partner_state) ||
      isMissing(targetData.partner_city) ||
      isMissing(targetData.partner_education) ||
      isMissing(targetData.partner_professional_qualification) ||
      isMissing(targetData.partner_occupation) ||
      isMissing(targetData.partner_working_as) ||
      isMissing(targetData.partner_annual_income)
    ) {
      window.location.href = "/partner-basic-detail-edit";
    } else {
      window.location.href = "/basic-details-edit";
    }
  };

  useEffect(() => {
    if (userDetailLogin._id) {
      checkProfileComplete(userDetailLogin._id)
    }

  }, [userDetailLogin])


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const handleScroll = () => {
      const btn = document.querySelector(".scrollToTop");
      if (btn) {
        if (window.scrollY > 300) {
          btn.classList.add("showBtn");
        } else {
          btn.classList.remove("showBtn");
        }
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercent = (scrollTop / (documentHeight - windowHeight)) * 100;
      const progressBar = document.getElementById('progress-bar');
      if (progressBar) {
        const dashOffset = (scrollPercent / 100) * 154;
        progressBar.style.setProperty('--scrollAmount', `${dashOffset}px`);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <ConfirmPopupHeader ref={modalConfirmRef} message={popupMessage} yesNoButton={confirmYesNo ? yesNoButtonTwo : yesNoButton} />


      <button className="scrollToTop showBtn"><span id="progress-bar" onClick={scrollToTop} style={{ "--scrollAmount": "19px" }}><svg width="48" height="48" viewBox="-5 -5 60 60" fill="none"><path stroke="#e85d95" strokeWidth="2" d="M0.5,25a24.5,24.5 0 1,0 49,0a24.5,24.5 0 1,0 -49,0"></path></svg></span></button>
      <section
        className="headerSection headerTwo wow animate__fadeIn"
        data-wow-delay="0.2s"
      >
        <div className="site-width sitewidths">
          <div className="headerWrapper">
            <div className="logoSection">
              <Link to="/dashboard">
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/logo-light.png`}
                  alt="Vivashri"
                  title="Vivashri"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </Link>
            </div>
            <div className="allHeaders wow animate__fadeIn">
              <div className="mainHeaderSection">
                <div className="headerNav">
                  <ul className="headerMenu">
                    <li className="hasSub megaMenu megaMenu2">
                      <Link to="#">
                        My Vivashri{" "}
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                          alt="down Icon"
                          className="dropdownicon"
                          style={{ marginLeft: 5 }}
                        />
                      </Link>
                      <div className="headerSubNav headerSubNavs">
                        <ul className="headerSubMenu">
                          {/* <li><h5>Horoscope</h5></li> */}
                          <li>
                            <Link to="/dashboard">Dashboard</Link>
                          </li>
                          <li>
                            <Link to="/my-profile/partner">Partner Preferences</Link>
                          </li>
                        </ul>
                        <ul className="headerSubMenu">
                          <li>
                            <Link to="/my-profile">My Profile</Link>
                          </li>
                          <li>
                            <Link to="/settings">Settings</Link>
                          </li>
                        </ul>
                        <ul className="headerSubMenu">
                          <li>
                            <Link to="/profile-photo-edit">My Photos</Link>
                          </li>
                          <li>
                            <Link to="#">Notification</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="hasSub megaMenu">
                      <Link to="#">
                        Matches{" "}
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                          alt="down Icon"
                          className="dropdownicon"
                          style={{ marginLeft: 5 }}
                        />
                      </Link>
                      <div className="headerSubNav headerSubNavsse ">
                        <ul className="headerSubMenu headerSubMenuss ">
                          {/* <li><h5>Horoscope</h5></li> */}
                          <li>

                            <Link to="/my-matches">My Matches</Link>
                          </li>
                          <li>
                            <Link to="/today-matches">Today Matches</Link>
                          </li>
                          <li>
                            <Link to="/near-me">Near Me</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className="hasSub megaMenu">
                      <Link to="#">
                        Search{" "}
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                          alt="down Icon"
                          className="dropdownicon"
                          style={{ marginLeft: 5 }}
                        />
                      </Link>
                      <div className="headerSubNav headerSubNavsss">
                        <ul className="headerSubMenu headerSubMenuss">
                          {/* <li><h5>Horoscope</h5></li> */}
                          <li>
                            <Link to="/basic-search">Basic Search</Link>
                          </li>

                          <li>
                            <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                          </li>


                        </ul>
                      </div>
                    </li>
                    <li className="hasSub megaMenu">
                      <Link to="#">
                        Connect{" "}
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                          alt="down Icon"
                          className="dropdownicon"
                          style={{ marginLeft: 5 }}
                        />
                      </Link>
                      <div className="headerSubNav headerSubNavssss">
                        <ul className="headerSubMenu headerSubMenuss">
                          {/* <li><h5>Horoscope</h5></li> */}
                          <li>
                            {/* {formData.form_status === 'Completed' ? */}
                            <Link to="/inbox/received">Received</Link>
                            {/* // :
                      // <Link onClick={showConfirm} to="#">Received</Link>
                      // } */}
                          </li>
                          <li>
                            {/* {formData.form_status === 'Completed' ? */}
                            <Link to="/inbox/accepted">Accepted</Link>
                            {/* // :
                      // <Link onClick={showConfirm} to="#">Accepted</Link>
                      // } */}
                          </li>
                          { /* <li>
                      <Link to="/inbox/decline">Decline</Link>
                    </li>
                    */ }
                          <li>
                            {/* {formData.form_status === 'Completed' ? */}
                            <Link to="/inbox/sent">Sent</Link>
                            {/* // :
                      // <Link onClick={showConfirm} to="#">Sent</Link>
                      // } */}
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


            <div className="headerButns dnone-but butt-pro-siz myprof-menu">

              <ul className="headerMenu">
                <li className="hasSub megaMenu" style={{ padding: '0px' }}>
                  <Link to="/dashboard" style={{ borderBottom: "none" }}>
                    <div className='myprof-img'>
                      <img
                        className="size-togle-pro"
                        src={getImageUrl(
                          formData?.photo,
                          formData?.gender === "Male"
                            ? "/assets/img/no-image-male.jpg"
                            : "/assets/img/no-image-female.jpg"
                        )}
                        alt=""
                      />
                    </div>
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                      alt="down Icon"
                      className="dropdownicon d-none d-lg-inline"
                      style={{ marginLeft: 5 }}
                    />
                  </Link>
                  <div className="headerSubNav headerSubNavsssss">
                    <ul className="headerSubMenu" style={{ width: '100%' }}>
                      {/* <li><h5>Horoscope</h5></li> */}
                      <li
                        style={{ backgroundColor: "#FFF9F0", padding: "15px 30px" }}
                      >
                        <h6 style={{ fontSize: 16, marginBottom: 10 }}>
                          {formData.name}{" "}
                          <span style={{ color: "#E4189F", fontSize: 12 }}>
                            { /* (ID :&nbsp;600155) */}
                          </span>
                        </h6>
                        <div className="col-12">
                          <div className="row">
                            <div className="col-7">
                              <h6 style={{ fontSize: 14 }}>
                                Active Plan: {formData.planDetail?.plan_id?.name?.toLowerCase().includes('vip') ? 'VIP Shaadi' : formData.planDetail?.plan_id?.name ? formData.planDetail?.plan_id?.name + ' Plan' : 'Free Plan'}
                              </h6>
                            </div>
                            <div className="col-5">
                              <h6 style={{ color: "#E4189F", fontSize: 13 }}>

                                {profileCompletion} {profileCompletion !== "100%" ? (
                                  <span onClick={() => handleCompleteProfile(profileCompletion, formData.data)}>
                                    Complete Profile
                                  </span>
                                ) : (
                                  <span>Complete Profile</span>
                                )}

                              </h6>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li
                        style={{ backgroundColor: "#ffffff", padding: "15px 30px" }}
                      >
                        <div className="col-12">
                          <div className="row">
                            <div className="col-6">
                              <Link to="/my-profile" style={{ border: "none", fontSize: 13 }}>
                                <img
                                  style={{ marginRight: 5 }}
                                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/user-alt-1_svgrepo.com.png`}
                                  alt=""
                                />
                                View My Profile
                              </Link>
                            </div>
                            <div className="col-6">
                              <Link to="/shortlist" style={{ border: "none", fontSize: 13 }}>
                                <img
                                  style={{ marginRight: 5 }}
                                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/setting-1_svgrepo.com.png`}
                                  alt=""
                                />
                                Shortlist
                              </Link>
                            </div>
                            <div className="col-6">
                              <Link to="/photo-request" style={{ border: "none", fontSize: 13 }}>
                                <img
                                  style={{ marginRight: 5 }}
                                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/key_svgrepo.com.png`}
                                  alt=""
                                />
                                Photo Request
                              </Link>
                            </div>
                            <div className="col-6">
                              <Link to="#" onClick={userLogoutButton} style={{ border: "none", fontSize: 13 }}>
                                <img
                                  style={{ marginRight: 5 }}
                                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/logout.png`}
                                  alt=""
                                />
                                Logout
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

            { /* <div className="headerButns dnone-butts">
        <div className="headerRightMenuWrap">
          <ul className="headerRightMenu">
            <div className="hamburger is-md">
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
            </div>
          </ul>
        </div>
      </div>
      */ }

            <div className="dropdownmenu wow animate__fadeInDown">
              <div className="headerNav">
                <ul className="headerMenu">
                  <li className="hasSub megaMenu">
                    <Link to="#" style={{ color: "#7C172B" }}>
                      My Vivashri{" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className="headerSubNav headerSubNavs">
                      <ul className="headerSubMenu">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li>
                          <Link to="/my-profile/partner">Partner Preferences</Link>
                        </li>
                      </ul>
                      <ul className="headerSubMenu">
                        <li>
                          <Link to="/my-profile">My Profile</Link>
                        </li>
                        <li>
                          <Link to="/settings">Settings</Link>
                        </li>
                      </ul>
                      <ul className="headerSubMenu">
                        <li>
                          <Link to="/profile-photo-edit">My Photos</Link>
                        </li>
                        <li>
                          <Link to="#">Notification</Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="hasSub megaMenu">
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Matches{" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className="headerSubNav headerSubNavss">
                      <ul className="headerSubMenu headerSubMenuss">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/my-matches">My Matches</Link>
                        </li>
                        <li>
                          <Link to="/today-matches">Today Matches</Link>
                        </li>
                        <li>
                          <Link to="/near-me">Near Me</Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="hasSub megaMenu">
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Search{" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className="headerSubNav headerSubNavsss">
                      <ul className="headerSubMenu headerSubMenuss">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link href="/basic-search">Basic Search</Link>
                        </li>

                        <li>
                          <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                        </li>

                      </ul>
                    </div>
                  </li>
                  <li className="hasSub megaMenu">
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Connect{" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className="headerSubNav headerSubNavssss">
                      <ul className="headerSubMenu headerSubMenuss">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/inbox/received">Received</Link>
                        </li>
                        <li>
                          <Link to="/inbox/accepted">Accepted</Link>
                        </li>
                        { /* <li>
                    <Link to="/inbox/decline">Decline</Link>
                  </li>
                  */ }
                        <li>
                          <Link to="/inbox/sent">Sent</Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>


            <div className="headerButns dnone-buttsss">
              <div className="headerRightMenuWrap">
                <ul className="headerRightMenu headerRightMenus">
                  <div className="hamburger is-md" onClick={toggleHeader}>
                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                  </div>
                </ul>
              </div>
            </div>

            <div className={`dropdownmenu wow animate__fadeInDown ${isHeaderOpen ? "openMenu" : "closedMenu"}`}>
              <div className="headerNav">
                <ul className="headerMenu" style={{ color: "black" }}>
                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenu}>
                    <Link to="#" style={{ color: "#7C172B" }}>
                      My Vivashri {" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className={`headerSubNav ${openMegaMenu ? "openMegaMenu" : "openMegaMenuClosed"}`}>
                      <ul className="headerSubMenu">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li>
                          <Link to="/my-profile">My Profile</Link>
                        </li>
                        <li>
                          <Link to="/profile-photo-edit">My Photos</Link>
                        </li>
                        <li>
                          <Link to="/my-profile/partner">Partner Preference</Link>
                        </li>
                        <li>
                          <Link to="/settings">Settings</Link>
                        </li>
                        <li>
                          <Link to="#">Notification</Link>
                        </li>
                      </ul>

                    </div>
                  </li>
                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuMatch}>
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Matches {" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className={`headerSubNav ${openMegaMenuMatch ? "openMegaMenuMatch" : "openMegaMenuClosedMatch"}`}>
                      <ul className="headerSubMenu">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/my-matches">My Matches</Link>
                        </li>
                        <li>
                          <Link to="/today-matches">Today Matches</Link>
                        </li>
                        <li>
                          <Link to="/near-me">Near Me</Link>
                        </li>

                      </ul>

                    </div>
                  </li>
                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuSearch}>
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Search {" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className={`headerSubNav ${openMegaMenuSearch ? "openMegaMenuSearch" : "openMegaMenuClosedSearch"}`}>
                      <ul className="headerSubMenu">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/basic-search">Basic Search</Link>
                        </li>

                        <li>
                          <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                        </li>


                      </ul>

                    </div>
                  </li>
                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuInbox}>
                    <Link to="#" style={{ color: "#7C172B" }}>
                      Connect {" "}
                      <img
                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                        alt="down Icon"
                        className="dropdownicon"
                        style={{ marginLeft: 5 }}
                      />
                    </Link>
                    <div className={`headerSubNav ${openMegaMenuInbox ? "openMegaMenuInbox" : "openMegaMenuClosedInbox"}`}>
                      <ul className="headerSubMenu">
                        {/* <li><h5>Horoscope</h5></li> */}
                        <li>
                          <Link to="/inbox/received">Received</Link>
                        </li>
                        <li>
                          <Link to="/inbox/accepted">Accepted</Link>
                        </li>
                        { /* <li>
                                          <Link to="/inbox/decline">Decline</Link>
                                        </li>
                                        */ }
                        <li>
                          <Link to="/inbox/sent">Sent</Link>
                        </li>


                      </ul>

                    </div>
                  </li>
                  <li>
                    {" "}
                    <Link to="#" onClick={userLogoutButton}>Logout</Link>
                  </li>




                </ul>

              </div>
            </div>


          </div>
        </div>
      </section>
    </>
  );
}

export default HeaderUser;
